export const ROUTES = {
    RBAC_CREATE_ROLE: '/api/v1/rbac/roles/create',
    RBAC_FEATURE_LIST: '/api/v1/rbac/features',
    RBAC_HIERARCHY_LIST: '/api/v1/rbac/roles/hierarchy/view',
    RBAC_GET_HIERARCHY_OPTIONS: '/api/v1/rbac/roles/hierarchy-options',
    RBAC_REMOVE_HIERARCHY_OPTION: (id) => `/api/v1/rbac/roles/hierarchy-options/delete/${id}`,
    RBAC_ADD_HIERARCHY_OPTIONS: '/api/v1/rbac/roles/hierarchy-options/',
    RBAC_UPDATE_HIERARCHY_OPTION: (id) => `api/v1/rbac/roles/hierarchy-options/update/${id}`,
    RBAC_GET_ROLE_DETAILS: (id) => `/api/v1/rbac/roles/details/${id}`,
}
